import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var complainRoute = [{
  path: "complain",
  name: "complain",
  component: function component() {
    return import("./complain.vue");
  }
}];